exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_AttachmentsContainer_1Jy4kyPEkJyT2F-rVLJzOe {\n  margin: 45px 40px 20px 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.IA_AttachmentsAttachment_XQOGn6Omtg6OYGf7KTOz_ {\n  display: flex;\n  align-items: center;\n}\n\n.IA_AttachmentsLink_2LiBdcTFTwZ_R_uvQkYZHO {\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_AttachmentsContainer": "IA_AttachmentsContainer_1Jy4kyPEkJyT2F-rVLJzOe",
	"IA_AttachmentsAttachment": "IA_AttachmentsAttachment_XQOGn6Omtg6OYGf7KTOz_",
	"IA_AttachmentsLink": "IA_AttachmentsLink_2LiBdcTFTwZ_R_uvQkYZHO"
};